module.exports = __webpack_public_path__ + "img/close.bf91c0b0.svg";